import React, { useState, useEffect } from "react";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { Col, Row, Button } from "reactstrap";
import AlertModal from "../../../../shared/components/Modal";
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { set } from "lodash";

const MedicalCheckbox = withStyles({
  root: {
    "&$checked": {
      color: "#4ce1b6",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const ModalContractsForm = ({
  third,
  contractThird,
  closeModal,
  opened,
  reloadContracts,
}) => {
  //Campos del Form Plan
  const [name, setName] = useState(null);
  const [type, setType] = useState(null);
  const [diasvencimiento, setDiasvencimiento] = useState(null);
  const [condic, setCondic] = useState(null);
  const [observ, setObserv] = useState(null);
  const [medicineInclude, setMedicineInclude] = useState(false);
  const [negociationType, setNegociationType] = useState(1);
  const [contractNum, setContractNum] = useState(null);
  const [wayPayment, setWayPayment] = useState(1);
  const [contractType, setContractType] = useState(1);
  const [formatoPropio, setFormatoPropio] = useState(false);
  const [formatoDetalle, setFormatoDetalle] = useState({
    nombre: "",
    direccion: "",
    telefono: "",
    nit: "",
    logo: "",
  });
  const [image, setImage] = useState(null);
  const [regimens, setRegimens] = useState([]);
  const [errors, setErrors] = useState({});
  const [openModal, setOpenModal] = useState(opened);
  const [showAlertModal, setAlerShowModal] = useState(false);
  const [messagAlerteModal, setAlertMessageModal] = useState(null);
  const [colorAlertModal, setAlertColorModal] = useState("success");

  const alertModal = (success, message) => {
    if (success == true) {
      setAlertColorModal("success");
    } else {
      setAlertColorModal("danger");
    }
    setAlerShowModal(true);
    setAlertMessageModal(message);
  };

  const closeAlertModal = () => {
    setAlerShowModal(false);
    if (colorAlertModal == "success") {
      close();
      reloadContracts();
    }
  };

  const cleanData = () => {
    setName(null);
    setErrors(null);
    setErrors({});
  };

  useEffect(() => {
    getRegimenList();
    mountContractFields();
  }, []);

  const mountContractFields = () => {
    if (contractThird != null) {
      setType(contractThird.regimen);
      setDiasvencimiento(contractThird.diasvencimiento);
      setObserv(contractThird.observaciones_condiciones);
      setMedicineInclude(contractThird.incluye_medicamento);
      setNegociationType(contractThird.tipo_negociacion);
      setContractNum(contractThird.numero_contrato);
      setContractType(contractThird.tipo_contrato);
      setWayPayment(contractThird.medio_pago);
      setFormatoPropio(!!contractThird.formato_propio);
      setFormatoDetalle({
        ...contractThird.formato_detalle?.formato_detalle?.[0],
      });
    }
  };

  const getRegimenList = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "regimen-contratos/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error(
            "Ha ocurrido un error listando los Regimenes Disponibles"
          );
        }
      })
      .then((res) => {
        setRegimens(res);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const resetForm = () => {
    setName(null);
    setType(null);
    setDiasvencimiento(null);
    setCondic(null);
    setObserv(null);
    setMedicineInclude(false);
    setNegociationType(1);
    setContractNum(null);
    setWayPayment(1);
    setContractType(1);
    setFormatoPropio(false);
    setFormatoDetalle({
      nombre: "",
      direccion: "",
      telefono: "",
      nit: "",
      logo: "",
    });
    setErrors({});
  };

  const validateFields = () => {
    let errors = {};
    let isError = false;
    if (contractNum == null) {
      errors.contractNum = "El número de contrato es Obligatorio";
      isError = true;
    } else {
      delete errors.contractNum;
    }
    if (type == null) {
      errors.type = "El Regimen es Obligatorio";
      isError = true;
    } else {
      delete errors.type;
    }
    if (diasvencimiento == null) {
      errors.diasvencimiento = "Los días de vencimiento son Obligatorios";
      isError = true;
    } else {
      delete errors.diasvencimiento;
    }
    if (negociationType == null) {
      errors.negociationType = "El tipo de negociación es Obligatorio";
      isError = true;
    } else {
      delete errors.negociationType;
    }
    if (wayPayment == null) {
      errors.wayPayment = "la forma de pago es Obligatoria";
      isError = true;
    } else {
      delete errors.wayPayment;
    }
    if (contractType == null) {
      errors.contractType = "El tipo de contrato es Obligatorio";
      isError = true;
    } else {
      delete errors.contractType;
    }
    if (formatoPropio == undefined) {
      errors.formatoPropio = "El formato propio es Obligatorio";
      isError = true;
    } else {
      delete errors.formatoPropio;
    }

    setErrors(errors);
    return isError;
  };

  const addContract = async () => {
    let isError = validateFields();
    if (isError) {
      return;
    }

    let dataSend = new FormData();
    dataSend.append("numero_contrato", contractNum);
    dataSend.append("id_tercero", third.id_tercero);
    dataSend.append("regimen", type);
    dataSend.append("diasvencimiento", diasvencimiento);
    dataSend.append("incluye_medicamento", medicineInclude);
    dataSend.append("observaciones_condiciones", observ);
    dataSend.append("tipo_negociacion", negociationType);
    dataSend.append("tipo_contrato", contractType);
    dataSend.append("medio_pago", wayPayment);
    dataSend.append("formato_propio", formatoPropio);
    dataSend.append(
      "formato_detalle",
      JSON.stringify({ formato_detalle: [{ ...formatoDetalle }] })
    );

    if (image) {
      dataSend.append("imagen", image);
    }
    await fetch(process.env.REACT_APP_PUBLIC_URL + "contratos/create", {
      method: "POST",
      headers: {
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: dataSend,
    })
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          alertModal(true, "Contrato agregado exitosamente");
          resetForm();
        } else {
          alertModal(false, "Ha ocurrido un error agregando el Plan");
          resetForm();
        }
      })
      .catch((error) => {
        alertModal(false, "Ha ocurrido un error agregando el Plan");
        resetForm();
      });
  };

  const updateContract = async () => {
    let isError = validateFields();
    if (isError) {
      return;
    }

    let dataSend = new FormData();
    dataSend.append("id_contrato", contractThird.id_contrato);
    dataSend.append("numero_contrato", contractNum);
    dataSend.append("diasvencimiento", diasvencimiento);
    dataSend.append("observaciones_condiciones", observ);
    dataSend.append("incluye_medicamento", medicineInclude);
    dataSend.append("regimen", type);
    dataSend.append("tipo_negociacion", negociationType);
    dataSend.append("tipo_contrato", contractType);
    dataSend.append("medio_pago", wayPayment);
    dataSend.append("formato_propio", formatoPropio);
    dataSend.append(
      "formato_detalle",
      JSON.stringify({ formato_detalle: [{ ...formatoDetalle }] })
    );
    if (image) {
      dataSend.append("imagen", image);
    }
    await fetch(process.env.REACT_APP_PUBLIC_URL + "contratos/update", {
      method: "PUT",
      headers: {
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: dataSend,
    })
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          alertModal(true, "Contrato actualizado exitosamente");
          resetForm();
        } else {
          alertModal(false, "Ha ocurrido un error actualizando el Contrato");
        }
      })
      .catch((error) => {
        alertModal(false, "Ha ocurrido un error actualizando el Contrato");
      });
  };

  const close = () => {
    cleanData();
    closeModal();
  };

  const handleChangeName = (name) => {
    if (name != "") {
      setName(name);
    } else {
      setName(null);
    }
  };

  const handleChangeType = (type) => {
    setType(type);
  };

  const handleChangeDaysVenc = (diasvencimiento) => {
    if (diasvencimiento != "") {
      setDiasvencimiento(diasvencimiento);
    } else {
      setDiasvencimiento(null);
    }
  };

  const handleChangeOberv = (observ) => {
    if (observ != "") {
      setObserv(observ);
    } else {
      setObserv(null);
    }
  };

  const handleChangeCondic = (condic) => {
    if (condic != "") {
      setCondic(condic);
    } else {
      setCondic(null);
    }
  };

  const handleChangeNegociationType = (contract) => {
    setNegociationType(contract);
  };

  const handleNumContract = (numContract) => {
    if (numContract != "") {
      setContractNum(numContract);
    } else {
      setContractNum(null);
    }
  };

  const handleChangeMedicineInclude = (_medicineInclude) => {
    setMedicineInclude(_medicineInclude);
  };

  const handleFormatoDetalle = (event) => {
    const { name, value } = event.target;
    setFormatoDetalle({ ...formatoDetalle, [name]: value });
  };

  return (
    <div>
      <Modal
        open={opened}
        onClose={(e) => {
          close();
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ zIndex: 1000 }}
      >
        <div
          className="paperAppointment-flex"
          style={{ width: "100%", margin: 10 }}
        >
          <div>
            <div className="card__title">
              {contractThird == null ? (
                <h5 className="bold-text">Agregar Contrato</h5>
              ) : (
                <h5 className="bold-text">Actualizar Contrato</h5>
              )}
            </div>
            <Row>
              <Row>
                <Col md={4}>
                  <TextField
                    label="Número de Contrato"
                    style={{ minWidth: "300px", maxWidth: "100%" }}
                    value={contractNum}
                    className="medical-material-form__field"
                    onChange={(event) => {
                      handleNumContract(event.target.value);
                    }}
                    InputLabelProps={{
                      style: { color: "#646777" },
                    }}
                    helperText={
                      errors.hasOwnProperty("contractNum") &&
                      contractNum == null
                        ? errors.contractNum
                        : ""
                    }
                    error={
                      errors.hasOwnProperty("contractNum") &&
                      contractNum == null
                        ? true
                        : false
                    }
                  ></TextField>
                </Col>
                <Col md={4}>
                  <TextField
                    select
                    label="Regimen"
                    value={type}
                    onChange={(event) => {
                      handleChangeType(event.target.value);
                    }}
                    style={{ minWidth: "300px", maxWidth: "100%" }}
                    className="medical-material-form__field"
                    InputLabelProps={{
                      style: { color: "#646777" },
                    }}
                    helperText={
                      errors.hasOwnProperty("type") && type == null
                        ? errors.type
                        : ""
                    }
                    error={
                      errors.hasOwnProperty("type") && type == null
                        ? true
                        : false
                    }
                  >
                    {regimens.map((reg) => {
                      return (
                        <MenuItem key={reg.id_regimen} value={reg.id_regimen}>
                          {reg.regimen}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Col>
                <Col md={4}>
                  <TextField
                    label="Días de vencimiento"
                    style={{ minWidth: "300px", maxWidth: "100%" }}
                    value={diasvencimiento}
                    className="medical-material-form__field"
                    type="number"
                    onChange={(event) => {
                      handleChangeDaysVenc(event.target.value);
                    }}
                    InputLabelProps={{
                      style: { color: "#646777" },
                    }}
                    helperText={
                      errors.hasOwnProperty("diasvencimiento") &&
                      diasvencimiento == null
                        ? errors.diasvencimiento
                        : ""
                    }
                    error={
                      errors.hasOwnProperty("diasvencimiento") &&
                      diasvencimiento == null
                        ? true
                        : false
                    }
                  ></TextField>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <TextField
                    select
                    label="Tipo de Negociación"
                    style={{ minWidth: "300px", maxWidth: "100%" }}
                    value={negociationType}
                    className="medical-material-form__field"
                    onChange={(event) => {
                      handleChangeNegociationType(event.target.value);
                    }}
                    InputLabelProps={{
                      style: { color: "#646777" },
                    }}
                    helperText={
                      errors.hasOwnProperty("negociationType") &&
                      negociationType == null
                        ? errors.negociationType
                        : ""
                    }
                    error={
                      errors.hasOwnProperty("negociationType") &&
                      negociationType == null
                        ? true
                        : false
                    }
                  >
                    <MenuItem key={1} value={1}>
                      CREDITO
                    </MenuItem>
                    <MenuItem key={2} value={2}>
                      CONTADO
                    </MenuItem>
                    <MenuItem key={3} value={3}>
                      OTROS
                    </MenuItem>
                  </TextField>
                </Col>

                <Col md={4}>
                  <TextField
                    select
                    label="Tipo de Contrato"
                    style={{ minWidth: "300px", maxWidth: "100%" }}
                    value={contractType}
                    className="medical-material-form__field"
                    onChange={(event) => {
                      setContractType(event.target.value);
                    }}
                    InputLabelProps={{
                      style: { color: "#646777" },
                    }}
                    helperText={
                      errors.hasOwnProperty("contractType") &&
                      contractType == null
                        ? errors.contractType
                        : ""
                    }
                    error={
                      errors.hasOwnProperty("contractType") &&
                      contractType == null
                        ? true
                        : false
                    }
                  >
                    <MenuItem key={3} value={1}>
                      POR EVENTO
                    </MenuItem>
                    <MenuItem key={4} value={2}>
                      CAPITACIÓN
                    </MenuItem>
                    <MenuItem key={5} value={3}>
                      PGP
                    </MenuItem>
                  </TextField>
                </Col>

                <Col md={4}>
                  <TextField
                    select
                    label="Medio de Pago"
                    style={{ minWidth: "300px", maxWidth: "100%" }}
                    value={wayPayment}
                    className="medical-material-form__field"
                    onChange={(event) => {
                      setWayPayment(event.target.value);
                    }}
                    InputLabelProps={{
                      style: { color: "#646777" },
                    }}
                    helperText={
                      errors.hasOwnProperty("wayPayment") && wayPayment == null
                        ? errors.wayPayment
                        : ""
                    }
                    error={
                      errors.hasOwnProperty("wayPayment") && wayPayment == null
                        ? true
                        : false
                    }
                  >
                    <MenuItem key={3} value={1}>
                      ACUERDO MUTUO
                    </MenuItem>
                    <MenuItem key={4} value={2}>
                      EFECTIVO
                    </MenuItem>
                    <MenuItem key={5} value={3}>
                      TRANSFERENCIA
                    </MenuItem>
                  </TextField>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <TextField
                    select
                    label="¿Maneja formato propio?"
                    style={{ minWidth: "300px", maxWidth: "100%" }}
                    value={formatoPropio}
                    className="medical-material-form__field"
                    onChange={(event) => {
                      setFormatoPropio(event.target.value);
                    }}
                    InputLabelProps={{
                      style: { color: "#646777" },
                    }}
                    helperText={
                      errors.hasOwnProperty("formatoPropio") &&
                      formatoPropio == null
                        ? errors.formatoPropio
                        : ""
                    }
                    error={
                      errors.hasOwnProperty("formatoPropio") &&
                      formatoPropio == null
                        ? true
                        : false
                    }
                  >
                    <MenuItem key={1} value={true}>
                      SI
                    </MenuItem>
                    <MenuItem key={2} value={false}>
                      NO
                    </MenuItem>
                  </TextField>
                </Col>
                {formatoPropio === true ? (
                  <>
                    <Col md={4}>
                      <TextField
                        label="Nit Entidad"
                        style={{ minWidth: "300px", maxWidth: "100%" }}
                        name="nit"
                        value={formatoDetalle.nit}
                        className="medical-material-form__field"
                        onChange={handleFormatoDetalle}
                        inputProps={{ maxLength: 11 }}
                        InputLabelProps={{
                          style: { color: "#646777" },
                        }}
                      ></TextField>
                    </Col>
                    <Col md={4}>
                      <TextField
                        label="Nombre de la entidad"
                        name="nombre"
                        style={{ minWidth: "300px", maxWidth: "100%" }}
                        value={formatoDetalle.nombre}
                        className="medical-material-form__field"
                        onChange={handleFormatoDetalle}
                        inputProps={{ maxLength: 40 }}
                        InputLabelProps={{
                          style: { color: "#646777" },
                        }}
                      ></TextField>
                    </Col>
                  </>
                ) : null}
              </Row>

              {formatoPropio === true ? (
                <Row>
                  <Col md={4}>
                    <TextField
                      label="Dirección de la entidad"
                      name="direccion"
                      style={{ minWidth: "300px", maxWidth: "100%" }}
                      value={formatoDetalle.direccion}
                      className="medical-material-form__field"
                      onChange={handleFormatoDetalle}
                      inputProps={{ maxLength: 45 }}
                      InputLabelProps={{
                        style: { color: "#646777" },
                      }}
                    ></TextField>
                  </Col>

                  <Col md={4}>
                    <TextField
                      label="Teléfono de la entidad"
                      name="telefono"
                      style={{ minWidth: "300px", maxWidth: "100%" }}
                      value={formatoDetalle.telefono}
                      className="medical-material-form__field"
                      onChange={handleFormatoDetalle}
                      inputProps={{ maxLength: 19 }}
                      InputLabelProps={{
                        style: { color: "#646777" },
                      }}
                    ></TextField>
                  </Col>

                  <Col md={4}>
                    <input
                      id="logo"
                      accept="image/*"
                      style={{ marginTop: 28 }}
                      name="logo"
                      type="file"
                      onChange={(e) => {
                        setImage(e.target.files[0]);
                        setFormatoDetalle({
                          ...formatoDetalle,
                          logo: e.target.files[0].name,
                        });
                      }}
                    />
                  </Col>
                </Row>
              ) : null}

              <Col md={12}>
                <br />
                <div className="form">
                  <div className="form__form-group">
                    <span className="form__form-group-label">
                      <h5>Observaciones y Condiciones</h5>
                    </span>
                    <div className="form__form-group-field">
                      <textarea
                        name="textarea-observation"
                        value={observ}
                        onChange={(e) => {
                          handleChangeOberv(e.target.value);
                        }}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <div>
              <div id="dvChkxIncluyeMedicamentos">
                <FormControlLabel
                  id={"chkxIncluyeMedicamentos_FormLabel"}
                  value={medicineInclude}
                  control={
                    <MedicalCheckbox
                      id={"chkxAF"}
                      checked={medicineInclude}
                      onChange={(event, check) => {
                        handleChangeMedicineInclude(check);
                      }}
                      iconStyle={{ fill: "green" }}
                    />
                  }
                  label={"Incluir Medicamentos"}
                  labelPlacement={"Incluir Medicamentos"}
                />
              </div>
              {/* <span><b>Costo del Servicio:</b>{price != null ? price : 0}</span>
                            <br />
                            <span><b>Costo Total de Medicamentos:</b>{getTotalMedicinePrice()}</span>
                            <br />
                            <span><b>Costo Total:</b>{getTotalPrice()}</span> */}
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            {contractThird == null ? (
              <Button
                disabled={false}
                style={{ marginTop: 10, marginRight: 10 }}
                variant="contained"
                className="btn btn-primary btn-sm text-white"
                onClick={() => {
                  addContract();
                }}
              >
                Crear
              </Button>
            ) : (
              <Button
                disabled={false}
                style={{ marginTop: 10, marginRight: 10 }}
                variant="contained"
                className="btn btn-primary btn-sm text-white"
                onClick={() => {
                  updateContract();
                }}
              >
                Actualizar
              </Button>
            )}
            <Button
              style={{ marginTop: 10 }}
              variant="contained"
              className="btn btn-secondary btn-sm"
              onClick={() => {
                close();
              }}
            >
              Cerrar
            </Button>
          </div>
        </div>
      </Modal>

      <AlertModal
        color={colorAlertModal}
        title={messagAlerteModal}
        modal={showAlertModal}
        onOk={() => closeAlertModal(false)}
      />
    </div>
  );
};
export default ModalContractsForm;
